module.exports = __webpack_public_path__ + "static/iot-device@3x-8bf3f20e073b6ed45cea27f8774d7404.png";